import React from "react";
import { Fade } from "react-awesome-reveal";
import useMobile from "../../hooks/useMobile";
import { useManagerContext } from "../../context/HomeContext";

const Manager = () => {
  const mobile = useMobile();
  const { managerData } = useManagerContext();

  return (
    <>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-65db93bf elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default"
        data-id="65db93bf"
        data-element_type="section"
        data-settings='{"stretch_section":"section-stretched","background_background":"classNameic","hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
      >
        <div className="elementor-container elementor-column-gap-default">
          <div className="elementor-row">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-26e99dca"
              data-id="26e99dca"
              data-element_type="column"
              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap">
                  <section
                    className="elementor-section elementor-inner-section elementor-element elementor-element-1cb63fda elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="1cb63fda"
                    data-element_type="section"
                    data-settings='{"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
                  >
                    <div className="elementor-container elementor-column-gap-wider">
                      <div
                        className="elementor-row custom-row-element"
                        style={{ display: "flex", gap: "20px" }}
                      >
                        <div
                          className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-23623ec2"
                          data-id="23623ec2"
                          data-element_type="column"
                          data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                        >
                          <div
                            className="elementor-column-wrap elementor-element-populated"
                            style={{ overflow: mobile ? "hidden" : "unset" }}
                          >
                            <div className="elementor-widget-wrap">
                              <Fade
                                cascade
                                damping={0.2}
                                direction="right"
                                triggerOnce={true}
                              >
                                <div
                                  className="elementor-element elementor-element-5c535b3e elementor-invisible elementor-widget elementor-widget-heading"
                                  data-id="5c535b3e"
                                  data-element_type="widget"
                                  data-settings='{"_animation":"fadeInRight","hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                  data-widget_type="heading.default"
                                >
                                  <div className="elementor-widget-container">
                                    <h2 className="elementor-heading-title elementor-size-default">
                                      {managerData[0]?.title}
                                    </h2>
                                  </div>
                                </div>
                                <div
                                  className="elementor-element elementor-element-6386550d elementor-invisible elementor-widget elementor-widget-text-editor"
                                  data-id="6386550d"
                                  data-element_type="widget"
                                  data-settings='{"_animation":"fadeInRight","_animation_delay":400,"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                  data-widget_type="text-editor.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="elementor-text-editor elementor-clearfix">
                                      <p
                                        dangerouslySetInnerHTML={{
                                          __html: managerData[0]?.description,
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="elementor-element elementor-element-32a7b226 elementor-invisible elementor-widget elementor-widget-image"
                                  data-id="32a7b226"
                                  data-element_type="widget"
                                  data-settings='{"_animation":"fadeInRight","_animation_delay":800,"hoteller_image_is_animation":"false","hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                  data-widget_type="image.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="elementor-image custom-signature">
                                      <img
                                        src={`${process.env.REACT_APP_cmsUrl}${
                                          managerData[0]?.signature[0]?.media
                                            .url
                                        }`}
                                        className="size-full"
                                        alt="signature"
                                        style={{
                                          width: "auto",
                                          height: "80px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="elementor-element elementor-element-3a90b1f6 elementor-invisible elementor-widget elementor-widget-heading"
                                  data-id="3a90b1f6"
                                  data-element_type="widget"
                                  data-settings='{"_animation":"fadeInRight","_animation_delay":1600,"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                  data-widget_type="heading.default"
                                >
                                  <div className="elementor-widget-container">
                                    <h6 className="elementor-heading-title elementor-size-default">
                                      {managerData[0]?.name} -{" "}
                                      {managerData[0]?.position}
                                    </h6>
                                  </div>
                                </div>
                              </Fade>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-column elementor-col-66 elementor-inner-column elementor-element elementor-element-2c7e157c"
                          data-id="2c7e157c"
                          data-element_type="column"
                          data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                        >
                          <div className="elementor-column-wrap elementor-element-populated">
                            <div className="elementor-widget-wrap custom-manager-image">
                              <Fade delay={1000} triggerOnce={true}>
                                <div
                                  className="elementor-element elementor-element-1f2468cb stellar elementor-invisible elementor-widget elementor-widget-image custom-elementor-widget-image"
                                  data-id="1f2468cb"
                                  data-element_type="widget"
                                  data-settings='{"_animation":"fadeIn","_animation_delay":1600,"hoteller_image_is_animation":"false","hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                  data-widget_type="image.default"
                                  style={{ display: "flex", gap: "15px" }}
                                >
                                  <div
                                    className="elementor-widget-container"
                                    style={{ overflow: "hidden" }}
                                  >
                                    <div className="elementor-image custom-elementor-image">
                                      <img
                                        width="1001"
                                        height="715"
                                        src={`${process.env.REACT_APP_cmsUrl}${
                                          managerData[0]?.image_1[0]?.media.url
                                        }`}
                                        className="attachment-full size-full"
                                        alt="manager"
                                        style={{
                                          height: "500px",
                                          objectFit: "cover",
                                        }}
                                        // loading="lazy"
                                      />
                                      <div className="custom-gradient"></div>
                                    </div>
                                  </div>
                                  <div
                                    className="elementor-widget-container"
                                    style={{ overflow: "hidden" }}
                                  >
                                    <div className="elementor-image custom-elementor-image">
                                      <img
                                        width="1001"
                                        height="715"
                                        src={`${process.env.REACT_APP_cmsUrl}${
                                          managerData[0]?.image_2[0]?.media.url
                                        }`}
                                        className="attachment-full size-full"
                                        alt="manager"
                                        style={{
                                          height: "500px",
                                          objectFit: "cover",
                                        }}
                                        // loading="lazy"
                                      />
                                      <div className="custom-gradient"></div>
                                    </div>
                                  </div>
                                </div>
                              </Fade>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Manager;
